package top.wcpe.allincore.dsl.ir.model

/**
 * 主题目录中的不可变展示描述。
 *
 * 由 FR-UI-029 引入，编译期写入 [UiIr.themeDirectory]，运行时投影给主题选择器。
 */
class ThemeDescriptor(
    id: String?,
    displayName: String?,
    group: String?,
    order: Int,
    previewPrimary: String?,
    previewSurface: String?,
    previewOnSurface: String?,
) {
    val id: String = id ?: throw NullPointerException("id")
    val displayName: String = displayName ?: throw NullPointerException("displayName")
    val group: String = group ?: throw NullPointerException("group")
    val order: Int = order
    val previewPrimary: String = previewPrimary ?: throw NullPointerException("previewPrimary")
    val previewSurface: String = previewSurface ?: throw NullPointerException("previewSurface")
    val previewOnSurface: String = previewOnSurface ?: throw NullPointerException("previewOnSurface")

    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other !is ThemeDescriptor) return false
        return order == other.order &&
            id == other.id &&
            displayName == other.displayName &&
            group == other.group &&
            previewPrimary == other.previewPrimary &&
            previewSurface == other.previewSurface &&
            previewOnSurface == other.previewOnSurface
    }

    override fun hashCode(): Int {
        var result = 1
        result = 31 * result + id.hashCode()
        result = 31 * result + displayName.hashCode()
        result = 31 * result + group.hashCode()
        result = 31 * result + order
        result = 31 * result + previewPrimary.hashCode()
        result = 31 * result + previewSurface.hashCode()
        result = 31 * result + previewOnSurface.hashCode()
        return result
    }

    override fun toString(): String =
        "ThemeDescriptor{" + id + ", displayName=" + displayName +
            ", group=" + group + ", order=" + order + "}"
}
